module.exports = __webpack_public_path__ + "img/ic_20_external.e11ecada.svg";